var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGraphIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74.032 62.414",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".graph_icon_svg__a,.graph_icon_svg__b{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}.graph_icon_svg__b{fill-rule:evenodd}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-svg-primary": "stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "graph_icon_svg__a",
    d: "M71.681 9.178V57.56M59.568 21.588v37.061M47.445 28.676v32.738M35.323 35.764v21.795M23.2 46.4v6.277"
  }), /*#__PURE__*/React.createElement("path", {
    className: "graph_icon_svg__b",
    d: "M1.414 52.218l15.61-15.616 4.62 4.62L43.87 18.985l5.593 5.593L72.618 1.414"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGraphIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/graph_icon.4ebf06363557c33e134a2b386bdcae65.svg";